import Parse from 'parse';

import { Injectable } from '@angular/core';

import { AssetAnalysisStatus } from '@analysis/domain';
import { type AssetStatusQuery, type AssetStatusRepository } from '@analysis/use-cases';
import { AlgorithmTopology } from '@telespot/infrastructure/parse';
import { CloudFunctions } from '@telespot/sdk';

@Injectable({ providedIn: 'root' })
export class TelespotAssetStatusRepository implements AssetStatusRepository {
  public async getAssetStatus(query: AssetStatusQuery): Promise<AssetAnalysisStatus[]> {
    const { sampleId, assetIds, analystId, analystEntity } = query;

    const createdBy =
      analystEntity === 'user'
        ? Parse.User.createWithoutData(analystId)
        : Parse.Object.extend(AlgorithmTopology.TABLE).createWithoutData(analystId);

    return CloudFunctions.GetRefStripData({
      sampleId,
      createdBy: createdBy.toPointer(),
      itemsToFetch: assetIds,
    });
  }
}
